module.exports = class BulkTransferShowContainerCtrl
  constructor: (BulkTransferService, $state) ->
    'ngInject'
    @BulkTransferService = BulkTransferService
    @$state = $state

  $onInit: ->
    @bulkTransfer = @BulkTransferService.one(@$state.params.bulk_transfer_id).get().$object
